import React from 'react';
import ButtonSansStyle from './ButtonSansStyles';

interface Props {
    readonly jobTitle: string;
    readonly jobDescription: string;
    readonly onClickEdit: () => void;
    readonly onClickRemove: () => void;
}

function EntryCard({
    jobTitle,
    jobDescription,
    onClickEdit,
    onClickRemove,
}: Props) {
    return (
        <div className="flex rounded-lg justify-between border border-gray-100 bg-gray-50 shadow-sm w-full min-h-[75px] sm:h-[75px] mb-4">
            <div className="flex flex-col my-auto pl-4">
                <p className="text-gray-500 font-instrument-sans text-base font-bold leading-6">{jobTitle}</p>
                <p className="text-gray-500 font-instrument-sans text-base font-normal leading-6 w-5/6 sm:w-full max-w-[295px]">{jobDescription}</p>
            </div>

            <div className="flex gap-3 items-center pr-4 pl-4">
                <ButtonSansStyle onClick={onClickEdit}>
                    <img className="w-3 h-3" src="/images/bio/edit-outline.png" alt="edit" />
                </ButtonSansStyle>
                <ButtonSansStyle onClick={onClickRemove}>
                    <img className="w-3 h-3" src="/images/bio/trash-outline.png" alt="trash" />
                </ButtonSansStyle>
            </div>
        </div>
    );
}

export default EntryCard;
